import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Box, Switch, Typography } from '@material-ui/core'

import { Card } from 'components'
import { Table, TableBody, TableCell, TableRow } from 'components/Table'

import useStyles from './styles'

const BaseMultiPermissionsForm = ({
  title,
  permissionsLists,
  register,
  permissions,
  handleChange,
  activeProfile,
  isEdit,
}) => {
  const classes = useStyles()

  const handleSwitchOnChange = (event, permission) => {
    if (activeProfile || !isEdit) {
      handleChange(event.target.checked, permission.tag)
    }
  }

  return (
    <Card dropdown title={title}>
      <Table>
        <TableBody>
          {permissionsLists?.map((permissionsList, index) => (
            <Fragment key={permissionsList.title ?? index}>
              {permissionsList.title && (
                <TableRow>
                  <TableCell colSpan={2} align="left" disableTooltip>
                    <Typography variant="subtitle2" color="textSecondary">
                      {permissionsList.title}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {permissionsList.permissions?.map((permission) => (
                <TableRow key={permission.tag}>
                  <TableCell
                    width="90%"
                    align="left"
                    className={classes.labelCell}
                    disableTooltip
                    noOverFlow
                  >
                    <Box ml={2}>
                      {permission.name}
                      {permission?.description && (
                        <Typography variant="body2">
                          {permission?.description}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell width="10%" align="left" disableTooltip>
                    <Switch
                      color="primary"
                      name={`permissions[${permission.tag}]`}
                      inputRef={register}
                      checked={
                        isEdit
                          ? permissions[permission.tag] ?? true
                          : permissions[permission.tag]
                      }
                      onChange={(event) =>
                        handleSwitchOnChange(event, permission)
                      }
                    />
                  </TableCell>
                </TableRow>
              ))}
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </Card>
  )
}

BaseMultiPermissionsForm.propTypes = {
  title: PropTypes.string,
  permissionsLists: PropTypes.array,
  register: PropTypes.func,
  permissions: PropTypes.object,
  handleChange: PropTypes.func,
  activeProfile: PropTypes.bool,
  isEdit: PropTypes.bool,
}

BaseMultiPermissionsForm.defaultProps = {
  permissions: {},
  handleChange: () => {},
}

export default BaseMultiPermissionsForm
